import fetchModels from "../../mixin/store/api/fetchModels";
import changeOrPushModel from "../../mixin/store/api/changeOrPushModel";
import fetchModel from "@/mixin/store/api/fetchModel";
import deleteModel from "@/mixin/store/api/deleteModel";

export default {
    actions: {
        fetchProductCategory(context, id) {
            return fetchModel(context, 'product_categories', id, 'updateProductCategory');
        },
        fetchProductCategories(context, data) {
            return fetchModels(context, 'product_categories', data.page, 'updateProductCategories');
        },
        fetchProductCategoriesTree(context, page) {
            return fetchModels(context, 'product_categories?exists[parent]=false', page, 'updateProductCategoriesTree');
        },
        pushProductCategories(context, data) {
            return changeOrPushModel(context, 'product_categories', data)
        },
        deleteProductCategory(context, id) {
            return deleteModel(context, 'product_categories', id);
        },
    },
    mutations: {
        updateProductCategory(state, data) {
            state.productCategory = data
        },
        updateProductCategories(state, data) {
            state.productCategories = data
        },
        updateProductCategoriesTree(state, data) {
            state.productCategoriesTree = data
        }
    },
    state: {
        productCategory: {
            name: null,
            parent: null,
        },
        productCategories: {
            models: [],
            totalItems: 0,
        },
        productCategoriesTree: {
            models: [],
            totalItems: 0,
        },
    },
    getters: {
        getProductCategory(state) {
            return state.productCategory
        },
        getProductCategories(state) {
            return state.productCategories.models
        },
        getProductCategoriesTree(state) {
            return state.productCategoriesTree.models
        },
        getProductCategoriesTotalCount(state) {
            return state.productCategories.totalItems
        }
    },
}
